export default {
  title: 'graphie',
  standard: 'proxima-soft',
};
